export const textsPasswordRecoveryPage: string[] = [
    /* 0 */'ВОССТАНОВЛЕНИЕ ПАРОЛЯ',
    /* 1 */'Укажите email',
    /* 2 */'Введите свой электронный адрес и мы отправим вам ссылку для восстановления доступа к аккаунту',
    /* 3 */'ПОЛУЧИТЬ ССЫЛКУ',
    /* 4 */'Ошибка',
    /* 5 */'Ошибка сервера',
    /* 6 */'Пустое поле email',
    /* 7 */'Введите корректный email'
]